module.exports = __webpack_public_path__ + "static/media/Teams.9e2b0201.svg";